module.exports = __webpack_public_path__ + "static/media/teameditor_icon_team_assistant.29402871.svg";